"use strict";

var _require = require("lodash"),
    invert = _require.invert;

var aminoAcidToDegenerateRnaMap = require("./aminoAcidToDegenerateRnaMap");

var degenerateRnaToAminoAcidMap = invert(aminoAcidToDegenerateRnaMap);
module.exports = degenerateRnaToAminoAcidMap;